/**
 * @name EMAM.Entry.js
 *
 * @author Anchor Group
 *
 * @since last updated date 2024-02-06
 *
 * @file Makes the My Account Menu fully configurable.
 */

define("EMAM.Entry", ["EMAM.Module", "jQuery", "underscore"], function (EMAMModule, jQuery, _) {
    "use strict";

    return {
        mountToApp: function mountToApp(container) {
            var promise = jQuery.Deferred(),
                user_role = "";

            container.getUser().then(function (profile) {
                if (profile.get("isLoggedIn") == "T") {
                    user_role = profile.get("user_role");
                }
                promise.resolve();

                EMAMModule.load(container, user_role);
            });

            container.waitForPromise(promise);
        },
    };
});
